/* SENSEZ · Tarjeta B: compra rápida desde la colección (Etapa 1 · B1).
   Elegir talla → "Agregar al carrito" → se agrega esa variante y se abre el carrito de Dawn (notificación o drawer).
   - Stock: el render viene del inventario de Shopify; al primer toque en una tarjeta se sincronizan todas sus tallas
     con /products/<handle>.js (variant.available). Shopify vuelve a validar el stock al agregar.
   - Sin "Última unidad": no se puede verificar la cantidad exacta en el momento del toque (la API pública solo dice
     disponible / agotado), así que no se muestra urgencia.
   - "Selecciona tu talla" es solo un estado (botón deshabilitado); la acción empieza tocando una talla.
   - Sin doble envío: la tarjeta queda bloqueada mientras se agrega.
   - La foto y el nombre siguen llevando a la ficha del producto (enlace de Dawn). */
(() => {
  const cache = new Map();
  function liveProduct(handle, force) {
    if (force || !cache.has(handle)) {
      cache.set(handle, fetch(`/products/${handle}.js`, { cache: 'no-store' }).then((r) => (r.ok ? r.json() : null)).catch(() => null));
      setTimeout(() => cache.delete(handle), 30000);
    }
    return cache.get(handle);
  }

  const $ = (card, sel) => card.querySelector(sel);
  const hint = (card, text) => { const h = $(card, '.sz-cardb__hint'); if (h) h.textContent = text || ''; };
  const addBtn = (card) => $(card, '.sz-cardb__add');

  function resetCta(card) {
    const add = addBtn(card);
    if (!add) return;
    add.dataset.variantId = '';
    add.disabled = true;
    add.textContent = add.dataset.prompt || 'Selecciona tu talla';
  }

  function markOut(chip) {
    chip.disabled = true;
    chip.classList.add('is-out');
    chip.classList.remove('is-selected');
    chip.setAttribute('aria-pressed', 'false');
    chip.removeAttribute('data-variant-id');
    if (!/agotada$/.test(chip.getAttribute('aria-label') || '')) chip.setAttribute('aria-label', `${chip.getAttribute('aria-label')}, agotada`);
  }
  function markIn(chip, id) {
    chip.disabled = false;
    chip.classList.remove('is-out');
    chip.dataset.variantId = id;
    chip.setAttribute('aria-label', (chip.getAttribute('aria-label') || '').replace(/, agotada$/, ''));
  }

  // Sincroniza todas las tallas de la tarjeta con el stock en vivo
  async function sync(card, force) {
    if (card.dataset.quick !== 'true') return;
    const p = await liveProduct(card.dataset.handle, force);
    if (!p) return;
    const idx = Number(card.dataset.opt);
    card.querySelectorAll('.sz-sz[data-value]').forEach((chip) => {
      const v = p.variants.find((x) => x.options[idx] === chip.dataset.value);
      if (!v) return;
      if (v.available) { if (chip.classList.contains('is-out')) markIn(chip, v.id); }
      else if (!chip.classList.contains('is-out')) {
        const wasSelected = chip.classList.contains('is-selected');
        markOut(chip);
        if (wasSelected) { resetCta(card); hint(card, `${chip.textContent.trim()} se acaba de agotar`); }
      }
    });
    card.dataset.synced = '1';
  }
  // Precarga al primer contacto con la tarjeta (antes del clic)
  ['pointerdown', 'focusin'].forEach((t) => document.addEventListener(t, (ev) => {
    const card = ev.target.closest && ev.target.closest('.sz-cardb[data-quick="true"]');
    if (card && !card.dataset.synced) sync(card);
  }, { passive: true }));
  // Volver atrás desde otra página (bfcache): stock fresco
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) document.querySelectorAll('.sz-cardb[data-synced]').forEach((c) => sync(c, true));
  });

  function select(card, chip) {
    card.querySelectorAll('.sz-sz').forEach((c) => { c.classList.remove('is-selected'); c.setAttribute('aria-pressed', 'false'); });
    chip.classList.add('is-selected');
    chip.setAttribute('aria-pressed', 'true');
    const add = addBtn(card);
    if (add) { add.dataset.variantId = chip.dataset.variantId; add.disabled = false; add.textContent = 'Agregar al carrito'; }
    hint(card, '');
  }

  async function addToCart(card, add) {
    const id = add.dataset.variantId;
    if (!id || card.dataset.busy) return;
    card.dataset.busy = '1';
    add.disabled = true;
    add.textContent = 'Agregando…';
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = { id: Number(id), quantity: 1 };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(add);
    }
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const data = await res.json();
      if (!res.ok || data.status) {
        const err = new Error(data.description || data.message || 'error');
        err.status = res.status;
        throw err;
      }
      if (cart && typeof cart.renderContents === 'function') {
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sz-card', productVariantId: id, cartData: data });
      document.dispatchEvent(new CustomEvent('sz:added', { detail: { variantId: id, item: data } }));
      add.textContent = 'Agregado ✓';
      setTimeout(() => { add.textContent = 'Agregar al carrito'; add.disabled = false; delete card.dataset.busy; }, 1500);
    } catch (e) {
      delete card.dataset.busy;
      const chip = card.querySelector('.sz-sz.is-selected');
      if (e.status === 422 && chip) {
        // Shopify rechazó por stock: se vuelve a leer el stock real antes de decidir el mensaje
        await sync(card, true);
        if (chip.classList.contains('is-out')) hint(card, `${chip.textContent.trim()} se acaba de agotar`);
        else { hint(card, 'Ya tienes en el carrito todas las unidades disponibles de esta talla'); add.disabled = false; add.textContent = 'Agregar al carrito'; return; }
        resetCta(card);
      } else {
        hint(card, 'No se pudo agregar. Intenta de nuevo');
        add.disabled = false;
        add.textContent = 'Agregar al carrito';
      }
    }
  }

  document.addEventListener('click', async (ev) => {
    const chip = ev.target.closest('.sz-cardb .sz-sz[data-variant-id]');
    if (chip) {
      ev.preventDefault();
      const card = chip.closest('.sz-cardb');
      if (card.dataset.quick !== 'true' || chip.disabled || card.dataset.busy) return;
      select(card, chip); // respuesta inmediata; la sincronización en vivo corrige si cambió el stock
      sync(card);
      return;
    }
    const add = ev.target.closest('.sz-cardb__add');
    if (add && !add.disabled) {
      ev.preventDefault();
      addToCart(add.closest('.sz-cardb'), add);
    }
  });
})();
